<template>
  <div class="rank-item-wrapper">
    <Row type="flex" align="center">
      <Col span='3'>
        <img class="rank-item-img" v-if="rank <= 3" :src="rankImg" />
        <div class="rank-item-img__text" v-else>{{rank}}</div>
      </Col>
      <Col span='4'>
        <img class="rank-item-avatar" :src="avatar">
      </Col>
      <Col span='12'>
        <div class="rank-item-name overflow-1">{{nickname}}</div>
        <div class="rank-item-intro overflow-1">{{intro}}</div>
      </Col>
      <Col span='5'>
        <div class="rank-item-number">{{ type == 'post' ? dataNumber + '条' : '积分：' + dataNumber}}</div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { Row, Col } from 'vant'
export default {
  name: 'RankItem',
  components: { Row, Col },
  props: {
    type: {
      type: String,
      default: 'post'
    },
    rank: {
      type: Number,
      default: 1
    },
    avatar: {
      type: String,
      default: ''
    },
    nickname: {
      type: String,
      default: ''
    },
    intro: {
      type: String,
      default: ''
    },
    dataNumber: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      rankImg: this.rank <= 3 ? require('../../../assets/ranking/rank_' + this.rank + '.png') : ''
    }
  },
  created () {

  },
  methods: {}
}
</script>
<style lang="less">
@import '../../../style/base.less';
.rank-item{
  &-wrapper{
    padding: 0 23px;
    margin-bottom: 25px;
  }
  &-img{
    width: 25px;
    height: 25px;
    display: block;
    &__text{
      display: block;
      width: 25px;
      height: 25px;
      text-align: center;
      line-height: 25px;
      color: #B0B4C4;
      font-size: 16px;
      font-weight: 800;
    }
  }
  &-avatar{
    width: 40px;
    height: 40px;
    display: block;
    border-radius: 50%;
  }
  &-name{
    font-size: 14px;
    color: #3a3a55;
  }
  &-intro{
    font-size: 13px;
    color: #b0b4c4;
    padding-top: 5px;
  }
  &-number{
    float: right;
    font-size: 13px;
    color: #70768f;
  }
}
</style>
